import { create } from "zustand";

import axios from "../helper/axios";

const useMembersStore = create((set) => ({
    teamMembers: [],
    vendors: [],
    clients:[],
    assignedTeamMembers: [],
    assignedVendorConnects: [],
    currSubscription:"trial_active", //start with it till the servers gets the real subscription

    getTeamMembers: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/users/${userData.qhoid}/role/TeamMember`
            );
            set({ teamMembers: response.data });
        } catch (err) {
            console.error(err);
        }
    },
    getVendors: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/users/${userData.qhoid}/role/VendorConnect`
            );

            set({ vendors: response.data });
        } catch (err) {
            console.error(err);
        }
    },
    getClients: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/getclients/${userData.qhoid}`
            );
            set({ clients: response.data });
            console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    },    
    getAssignedMembers: async (jdId) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log(userData);
            const response = await axios.get(
                `assigned/${userData.qhoid}/${userData.qhuid}/${jdId}/TeamMember`
            );
            set({ assignedTeamMembers: response.data });
            console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    },
    checkSubscriptions: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.get(
                `/checkSubscription/${userData.qhoid}/${userData.qhuid}`
            );
            set({ currSubscription: response.data.data });
            console.log(response.data);
        } catch (err) {
            console.error(err);
        }
    }, 
    setSubscription: async () =>{
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            if(userData.subscriptionstatus == "subscription_none"){
                set({ currSubscription: userData.trialstatus });
            }else{
                set({ currSubscription: userData.subscriptionstatus });
            }
            
        } catch (err) {
            console.error(err);
        }
    },  
    updateUserDetails: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            console.log(body);
            const response = await axios.post(
                `/updateUserDetails/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            console.log(response.data.name); 
            console.log(response.data.status);
        } catch (err) {
            console.error(err);
        }
    },   
}));

export default useMembersStore;
